export enum AtomButtonLinkSizeEnum {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}
